import React, { useState, useEffect } from "react";

import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin,toUpperCaseString } from "../../../../Shared/Utill/Utills";

import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
  } from '@mui/material';


  const DivisionDropDownComp = (props) => {
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const history = useNavigate();
    const [divList, setDivList] = useState([]);
    const [divSelectedValue, setDivSelectedValue] = useState(null);
    const [preSelectedDivNbr, setPreSelectedDivNbr] = useState(props.preSelectDivNbr ? props.preSelectDivNbr : null);
    const [readOnlyValue,setReadOnlyValue] = useState(props.readOnly ? props.readOnly : 'false');
    //alert(readOnlyValue)
    // check user role at page
    CheckIsUserAdmin();

    useEffect(() => {
        //call the API source for division list
        getDivisionListSource();
       },[]); 

    useEffect(() => {
        props.onDivChange(divSelectedValue);
    },[divSelectedValue]);

    useEffect(() => {
      setReadOnlyValue(props.readOnly);
  },[props.readOnly]);

    useEffect(() => {
         setPreSelectedDivNbr(props.preSelectDivNbr);
    },[props.preSelectDivNbr]);

    useEffect(() => {
      setPreselectedDivValue();
    }, [preSelectedDivNbr]);

    useEffect(() => {
      setPreselectedDivValue();
    }, [divList]);

    const setPreselectedDivValue = () => {
    if(preSelectedDivNbr == null){
      setDivSelectedValue(null);
      return;
    }  
    //  selected item
    let result = divList.find(e => {return e.divNbr == preSelectedDivNbr});
    if(result != undefined) {
       setDivSelectedValue(result);
    }else{
       setDivSelectedValue(null);
      }
    }

    const getDivisionListSource = () =>{
        //personDetails.mydiv; // my divNbr
        if(toUpperCaseString(personDetails.avail_admin) === "D"){
          getMyDivisionDetail();
        }
        else if(toUpperCaseString(personDetails.avail_admin) === "A"){
          getAllDivisionsList();
        }
        
    }
    //Network API request to get All divisions
  const getAllDivisionsList = () => {
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_ALL_DIVISIONS_URL}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      setDivList(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_ALL_DIVISIONS_URL}...failed`})
        }
    });

  }

  //Network API request to get my Division detail
  const getMyDivisionDetail = () => {
    let myDivNbr =personDetails.mydiv;
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}/${myDivNbr}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      let divList = [];
      divList.push(res.data);
      setDivList(divList);
      setDivSelectedValue(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}...failed`})
        }
    });

  }

  const onDivDropDownSelect = (event) => {
    let selectedDivision = event.target.value;
    setDivSelectedValue(selectedDivision);
  }

    return (
        <FormControl sx={{ minWidth: '100%'}}>
        <InputLabel id="demo-select-basic-label">Division*</InputLabel>
        <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        disabled={divList.length === 1 || readOnlyValue}
        inputProps={{ readOnly: readOnlyValue }}
        onChange={e => onDivDropDownSelect(e)}
        value={divSelectedValue || ''}
        sx={{
           "& .MuiInputBase-input.Mui-disabled": 
           {
           WebkitTextFillColor: "#000000",
           },
           }}
         >
        {divList && divList.map((e) =>
          <MenuItem key={e.divNbr} value={e}>{e.divNbr + "-" + e.divName}</MenuItem>
        )}
        </Select>
        </FormControl>
    );
  }

  export default DivisionDropDownComp;